import api from './'

export default {

    /**
     * Get expense requests
     * @param params
     */
    get(params = {}) {
        return api
            .get('/expenseRequests', {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create expense request
     * @param data
     * @param config
     */
    create(data, config) {
        return api
            .post(`/expenseRequests`, data, config)
            .then(response => {
                return response.data
            })
    },

    /**
     * Show expense request
     * @param expenseRequest
     * @param params
     */
    show(expenseRequest, params) {
        return api
            .get(`/expenseRequests/${expenseRequest}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Update expense request
     * @param expenseRequest
     * @param data
     * @param config
     */
    update(expenseRequest, data, config) {
        return api
            .put(`/expenseRequests/${expenseRequest}`, data, config)
            .then(response => {
                return response.data
            })
    },

    /**
     * Confirm expense request
     * @param expenseRequest
     * @param data
     */
    confirm(expenseRequest, data) {
        return api
            .post(`/expenseRequests/${expenseRequest}/confirm`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Decline expense request
     * @param expenseRequest
     * @param data
     */
    decline(expenseRequest, data) {
        return api
            .post(`/expenseRequests/${expenseRequest}/decline`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Ask rectification for expense request
     * @param expenseRequest
     * @param data
     */
    needRectification(expenseRequest, data) {
        return api
            .post(`/expenseRequests/${expenseRequest}/needRectification`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Rectify expense request
     * @param expenseRequest
     * @param data
     */
    rectified(expenseRequest, data) {
        return api
            .post(`/expenseRequests/${expenseRequest}/rectified`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Cancel expense request
     * @param expenseRequest
     * @param data
     */
    cancel(expenseRequest, data) {
        return api
            .post(`/expenseRequests/${expenseRequest}/cancel`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Retry to debit an expense request
     * @param expenseRequest
     * @param data
     */
    retryToDebit(expenseRequest, data) {
        return api
            .post(`/expenseRequests/${expenseRequest}/retryToDebit`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Add media
     *
     * @param expenseRequest
     * @param data
     */
    addMedia(expenseRequest, data) {
        return api
            .post(`/expenseRequests/${expenseRequest}/medias`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Set debit to failed
     * @param expenseRequest
    */
    setDebitFailed(expenseRequest) {
        return api
            .post(`/expenseRequests/${expenseRequest}/debitFailed`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Set debit to success
     * @param expenseRequest
    */
    setDebitSuccessful(expenseRequest) {
        return api
            .post(`/expenseRequests/${expenseRequest}/debitSuccessful`)
            .then(response => {
                return response.data
            })
    },
}
